import {useRef,useMemo} from "react";
import TaskDetailEmployeesPopup from './TaskDetailEmployeesPopup.js';
import COMPONENT_MAP from '../Repository/Components.js';

const TaskDetailEmployees=({parentId,application,userData})=>{
    const list_name='task_employees';
    const executeQuery=useRef(true);
    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                application={application}
                userData={userData}
                entityType={'TaskSystemUser'}
                entityParams={['task_id='+parentId,'_lang='+application.globalData.lang]}
                list_name={list_name}
                // height={'50vh'}
                file={'TaskDetailEmployees.js'}
                initialState={{}}
                navigateOnNew={null}
                popupComponent={TaskDetailEmployeesPopup}
                parentContext={{parent_field_name:'task_id',parent_field_value:null,parent_name:'Task'}}
                executeQuery={executeQuery}
            />
        ):null; 
    },[parentId,application,userData]);

    return(renderListTab);
}

export default TaskDetailEmployees;